export type OfferNumberRow={id:string;organization_id:string;quote_number:string|null};
type Preparation={
 organizationId:string;dealId:string;canGenerate:boolean;canUpdate:boolean;
 isCurrent:()=>boolean;read:()=>Promise<unknown>;calculate:()=>Promise<void>;
};
const uuid=/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;
/** Called only from an explicit document action; never from a record-load effect. */
export async function prepareOfferDocumentNumber(p:Preparation):Promise<string>{
 const current=()=>{if(!p.isCurrent())throw Error('document_context_changed');};
 current();
 if(!uuid.test(p.organizationId)||!uuid.test(p.dealId)||!p.canGenerate)throw Error('document_not_authorized');
 const read=async()=>{
  current();const value=await p.read();current();
  if(!value||typeof value!=='object')throw Error('document_number_read_failed');
  const row=value as OfferNumberRow;
  if(row.id!==p.dealId||row.organization_id!==p.organizationId)throw Error('document_scope_mismatch');
  if(row.quote_number!==null&&(typeof row.quote_number!=='string'||row.quote_number.length>128||/[\u0000-\u001f\u007f]/u.test(row.quote_number)))throw Error('document_number_invalid');
  return row.quote_number?.trim()||null;
 };
 const existing=await read();
 if(existing)return existing;
 if(!p.canUpdate)throw Error('document_number_update_not_authorized');
 current();await p.calculate();current();
 // The legacy calculator catches update errors: only a fresh persisted number is success.
 const verified=await read();
 if(!verified)throw Error('document_number_not_verified');
 return verified;
}
